import OfferLabels from 'components/Common/Labels/OfferLabels'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import LineEyeIcon from 'components/Luxkit/Icons/line/LineEyeIcon'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import { OFFER_VIEWS_THRESHOLD } from 'constants/offer'
import React, { ComponentProps } from 'react'

type InheritedOfferLabelsProps = Pick<ComponentProps<typeof OfferLabels>, 'showLimitedAvailability'>

interface Props extends InheritedOfferLabelsProps {
  offer: App.Offer | App.OfferSummary
  showViewsLabel?: boolean
  showBadge?: boolean
}

function OfferPageLabelGroup(props: Props) {
  const {
    offer,
    showViewsLabel,
    showBadge,
    showLimitedAvailability,
  } = props

  const isUrgencyTodayActive = showViewsLabel && offer.stats.views > OFFER_VIEWS_THRESHOLD

  return <LabelGroup>
    <OfferLabels offer={offer} showLimitedAvailability={showLimitedAvailability} />
    {isUrgencyTodayActive && <PromotionLabel variant="engagement" icon={<LineEyeIcon />}>
      Viewed <FormatDecimal value={offer.stats.views} /> times in 3 days
    </PromotionLabel>}
    {showBadge && !!offer.badge && <OfferBadgeLabel badge={offer.badge} />}
  </LabelGroup>
}

export default OfferPageLabelGroup
